import { useSelector } from "react-redux";
import { useGetCatalogAccountType } from "../../../fnx/getCatalogAccountType";
import { GetPersonById } from "../../../fnx/person/getPersonById";
var useSelectors = function (trigger, projectId, personTrigger, personId) {
    var _a = useSelector(function (state) { return ({
        responseCreatePolicy: state.Policy.responseCreatePolicy,
        errorCreatePolicy: state.Policy.errorCreatePolicy,
        loadingCreatePolicy: state.Policy.loadingCreatePolicy,
    }); }), responseCreatePolicy = _a.responseCreatePolicy, errorCreatePolicy = _a.errorCreatePolicy, loadingCreatePolicy = _a.loadingCreatePolicy;
    var _b = useGetCatalogAccountType(trigger, projectId), responseCatalogAccountType = _b.responseCatalogAccountType, errorCatalogAccountType = _b.errorCatalogAccountType;
    var _c = GetPersonById(personTrigger, personId), responsePersonById = _c.responsePersonById, errorPersonById = _c.errorPersonById, loadingPersonById = _c.loadingPersonById;
    var _d = useSelector(function (state) {
        var _a;
        return ({
            responseOneQuote: (_a = state.Quote.responseOneQuote) === null || _a === void 0 ? void 0 : _a.data,
            errorOneQuote: state.Quote.errorOneQuote,
            loadingOneQuote: state.Quote.loadingOneQuote,
        });
    }), responseOneQuote = _d.responseOneQuote, errorOneQuote = _d.errorOneQuote, loadingOneQuote = _d.loadingOneQuote;
    return {
        responseCreatePolicy: responseCreatePolicy,
        errorCreatePolicy: errorCreatePolicy,
        loadingCreatePolicy: loadingCreatePolicy,
        responseCatalogAccountType: responseCatalogAccountType,
        errorCatalogAccountType: errorCatalogAccountType,
        responsePersonById: responsePersonById,
        errorPersonById: errorPersonById,
        loadingPersonById: loadingPersonById,
        responseOneQuote: responseOneQuote,
        errorOneQuote: errorOneQuote,
        loadingOneQuote: loadingOneQuote,
    };
};
export default useSelectors;
